module.exports = __webpack_public_path__ + "static/media/thai-yellow-curry-chicken.e8c7c4d6.jpg";